import './FeatureFlagEditor.scss';
import React from 'react';

export interface FeatureFlagEditorProps {
    code: string;
    name: string;
    description: string;
    value: boolean;

    onChange(val: boolean): void;
}

const FeatureFlagEditor: React.FC<FeatureFlagEditorProps> = props => {
    return <div className="row feature-flag-editor">
        <div className="col-12">
            <label id={props.code} className="flag-name">
                <input type="checkbox" checked={props.value} onChange={ev => props.onChange(ev.target.checked)} /> {props.name}
            </label>
        </div>
        <div className="col">
            <p>{props.description}</p>
        </div>
    </div>;
}

export default FeatureFlagEditor;